import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BudgetService } from 'src/app/shared/services/budget.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ExclusiveService } from 'src/app/shared/services/exclusive.service';
import { AiEditSource } from 'src/app/shared/components/ai-edit-modal/ai-edit-modal.component';

@Component({
  selector: 'exclusive-budget-media-detail',
  templateUrl: './budget-media-detail.component.html',
  styleUrls: ['./budget-media-detail.component.scss']
})
export class BudgetMediaDetailComponent implements OnInit, OnChanges {
    @Output() imageDetailEvent = new EventEmitter<any>();
    @Input('id') id: any;
    @Input('collection') collection: any;
    @Input('type') type: any;

    private license: string;
    private subscription: any[] = [];
    public ackchk = false;

    images: any;
    public categories: any[] = [];
    public currentUser: any;
    public licenses = [
        {
            id: 'Standard',
            name: 'Standard',
            description: 'Limited usage in print, advertising and packaging. Unlimited web distribution',
            price: 4000
        },
        {
            id: 'Enhanced',
            name: 'Enhanced',
            description: 'Unlimited usage in print, advertising, packaging and merchandising. Unlimited web distribution',
            price: 5000
        }
    ];
    collectionSize: any;
    public wish: any;
    cartProduct: any;
    btn: number;
    public videoSize = [
        {
            id: 'Web',
            license: 'Web-240',
            price: 4000
        },
        {
            id: 'SD',
            license: 'SD',
            price: 5000
        }, {
            id: 'HD (720)',
            license: 'HD',
            price: 6000
        }, {
            id: 'HD (1080)',
            license: 'HD',
            price: 7000
        }, {
            id: '4K',
            license: '4K',
            price: 8000
        }
    ];
    public selectedSize: any;
    public categoryId: number;
    imageType = 'all';
    private isAnySizeDownoaded = 0;

    // Sections mirrored from media-detail (image details / related / keywords)
    mediaType = 'images';
    code = '';
    category = 'creative';
    relatedProducts: any[] = [];

    constructor(private appService: BudgetService, private authService: AuthenticationService,
                private toastService: ToastrService, private router: Router, private exclusiveService: ExclusiveService) {
        this.authService.currentUser.subscribe(x => this.currentUser = x);

        this.btn = 0;
        this.getCategories();
        this.license = this.licenses[0].id;
    }

    ngOnInit() {
        // First load: ngOnChanges may have fired before the inputs were resolved,
        // so trigger the load here once the inputs are guaranteed to be bound.
        if (this.id && this.collection && !this.images) {
            this.getImageById();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        // Skip the very first change (handled by ngOnInit) to avoid a double fetch;
        // reload only when the route inputs actually change afterwards.
        if (changes['id']?.firstChange || changes['collection']?.firstChange) {
            return;
        }
        this.images = undefined;
        this.btn = 0;
        this.license = this.licenses[0].id;
        this.selectedLicence = this.licenses[0].name;
        this.setLicensePrices();
        if (this.id && this.collection) {
            this.getImageById();
        }
    }

    private get adminFlag(): number {
        return (this.currentUser?.isAdmin as any)
            ?? 0;
    }

    public getCategories() {
    //   console.log('[budget-media-detail] getCategories called');
        // if (this.appService.Data.categories && this.appService.Data.categories.length) {
        //     this.categories = this.appService.Data.categories;
        //     this.setLicensePrices();
        //     console.log('[budget-media-detail] getCategories: using cached categories', this.categories);
        //     return;
        // }
        this.appService.getBudgetCategories().subscribe(data => {
            this.categories = data || [];
            this.appService.Data.categories = this.categories;
            this.setLicensePrices();
            // console.log('[budget-media-detail] getCategories: fetched categories', this.categories);
        });
    }

    private setLicensePrices() {
        const catPrice = (this.categories || []).filter(item => item.id == parseInt(this.collection))[0];
        if (catPrice && catPrice.price) {
            for (let i = 0; i < this.licenses.length; i++) {
                this.licenses[i].price = catPrice.price[this.licenses[i].name] ?? this.licenses[i].price;
            }
        }
    }

    public download(isSubscription: boolean) {
        if (this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true) && this.ackchk == false) {
            this.toastService.error('Please acknowledge that this image is for Editorial use only');
        } else {
            this.appService.downloadImage(this.cartProduct, isSubscription).subscribe((data: any) => {
                console.log('data ', data);
                this.subscription = data;
                /*
                 * The endpoint answers in two shapes. Success is the licence
                 * ARRAY assigned above — licenseSubscription() filters it by
                 * name. A failure is an object carrying data/message.
                 *
                 * Array.isArray first, because an array has no `.data` either:
                 * without it the guard read every successful download as a
                 * failure and stopped before the file was fetched.
                 */
                if(!Array.isArray(data) && data && data?.data == null){
                    this.toastService.error(data?.message || 'Problem in downloading image. Contact sales to resolve.');
                    return;
                }
                this.licenseSubscription();
                const siz = this.images.sizes.filter((item: any) => item.name == this.cartProduct.size)[0];

                const url = siz.download_link;
                if (this.cartProduct.type == 'image') {
                    this.isAnySizeDownoaded = 1;
                }

                const element = document.createElement('a');
                element.setAttribute('href', url);
                element.setAttribute('download', this.cartProduct.id + '');
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);

                if (url != null) {
                    this.btn = 2;
                }
            });
        }
    }

    public reDownloadImage(isSubscription: boolean) {
        if (this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true) && this.ackchk == false) {
            this.toastService.error('Please acknowledge that this image is for Editorial use only');
        } else {
            this.appService.reDownloadImageById(this.cartProduct, true).subscribe((data: any) => {
                if (data['data'] && data['data'] != '') {
                    const url = data['data'];

                    const element = document.createElement('a');
                    element.setAttribute('href', url);
                    element.setAttribute('download', this.cartProduct.id + '');
                    element.target = '_blank';
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    this.btn = 2;

                } else {
                    this.toastService.error('Problem in downloading image, Contact sales to resolve issue');
                }
            });
        }
    }

    public addToDownload() {
        this.exclusiveService.addToDownload(this.cartProduct, this.adminFlag)
            .subscribe((res: any) => {
                if (res && res.data) {
                    this.toastService.success('Image added to download list');
                } else {
                    this.toastService.error('Problem in downloading image. Contact sales to resolve.');
                }
            });
    }


    public addToCart() {
        const product = this.cartProduct;

        if (this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true) && this.ackchk == false) {
            this.toastService.error('Please acknowledge that this image is for Editorial use only');
            return;
        }

        if (this.currentUser && product.price > 0) {
            const currentProduct = this.appService.Data.cartList.filter((item: any) => item.id == product.id)[0];
            if (currentProduct) {
                this.toastService.error('Image already exist in your cart');
                return;
            }
            this.addToCartApi(product);
        } else {
            this.changeSize(this.selectedSize);
            this.toastService.error('Please sign-in to Purchase.');
        }
    }

    private addToCartApi(product: any) {
        this.appService.addToCartListDB(JSON.stringify(product), this.currentUser.customers_id).subscribe(data => {
            if (data.statusCode === 200) {
                this.appService.addToCart(data.data.imagesArray, data.data.total_price, data.data.total_item);
                let title = 'You Desire We Deliver! Added Your Favourtie ' + this.images.type + ' To The Cart.';
                if (this.images.type == 'video' || this.images.type == 'Video') {
                    title = 'Added Your Lovely Video Pick To The Cart';
                }
                this.toastService.success(title);
                // this.router.navigate(['/cart']);
            } else {
                this.toastService.error('Error in adding product to the cart');
            }
        });
    }

    public getImageById() {
        this.mediaType = (this.type == 'video' || this.type == 'videos') ? 'videos' : 'images';
        this.type = this.mediaType == 'videos' ? 'video' : 'image';
        this.appService.getImageById(this.id, this.collection, this.type).subscribe(data => {
            if (!data || (data.error && data.error != '')) {
                this.images = data;
            } else if (!data.sizes || !data.sizes.length) {
                // Valid response but no sizes: keep it visible but skip size-dependent processing.
                this.images = data;
            } else {
                this.images = data;

                this.selectedSize = this.images.sizes[(this.images.sizes.length - 1)];
                this.images.model = this.images.model + '';
                this.images.property = this.images.property + '';

                this.images.sizes.reverse();

                if (this.images.model == 'true' || this.images.model == '1') {
                    this.images.model = 'Yes';
                }
                if (this.images.model == 'false' || this.images.model == '0') {
                    this.images.model = 'No';
                }
                if (this.images.property == 'true' || this.images.property == '1') {
                    this.images.property = 'Yes';
                }
                if (this.images.property == 'false' || this.images.property == '0') {
                    this.images.property = 'No';
                }
                const videoCatPrice = (this.categories || []).filter(item => item.id == parseInt(this.collection))[0];
                if (this.images.type == 'video') {
                    this.images.sizes.map((obj: any) => {
                        obj.price = videoCatPrice?.price?.[obj.name] ?? obj.price;
                        return obj;
                    });
                } else {
                    this.images.type = 'image';
                }

                if (this.images.type == 'video') {
                    this.imageType = 'videos';
                }

                this.code = this.images.author;
                this.category = this.images.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true)
                    ? 'editorial' : 'creative';

                this.getSubscriptionDetail();
                this.getRelatedProducts();
                this.cartProduct = Object.assign({
                    id: data.id,
                    filename: data.filename,
                    thumbnail: data.thumbnail,
                    license: data.license,
                    collection: data.collection,
                    size: data.sizes[data.sizes.length - 1].name,
                    price: data.sizes[data.sizes.length - 1].price,
                    type: data.type ? data.type : 'image',
                    caption: data.caption,
                    category: this.categoryId == 1 ? 'creative' : 'editorial'
                });

                this.imageDetailEvent.emit({
                    images: this.images,
                    cartProduct: this.cartProduct
                });


                this.wish = Object.assign({}, this.images);
                this.wish.id = this.images.filename;
                this.wish.filename = this.images.id + '';
            }
        }, (err: any) => {
            console.error('[budget-media-detail] getImageById failed', err);
            this.toastService.error('Unable to load this media. Please try again.');
        });

    }

    /** Similar images shown: 12 at least where the library has them, 18 at most. Same rule as products/media-detail. */
    private static readonly SIMILAR_MIN = 12;
    private static readonly SIMILAR_MAX = 18;

    public getRelatedProducts() {
        this.relatedProducts = [];
        if (!this.images?.caption) {
            return;
        }
        this.searchSimilar(this.images.caption, rows => {
            this.setRelated(rows);
            this.topUpSimilar();
        });
    }

    private searchSimilar(text: string, done: (rows: any[]) => void): void {
        this.appService.getImages(text, 25, 1, '', true).subscribe((result: any) => {
            done(result?.results || []);
        }, (err: any) => {
            console.error('[budget-media-detail] getRelatedProducts failed', err);
        });
    }

    /** At most SIMILAR_MAX, without the image being viewed and without duplicates. */
    private setRelated(rows: any[]): void {
        const seen = new Set<string>([this.images?.collection + ':' + this.images?.id]);

        this.relatedProducts = (rows || [])
            .filter((row: any) => {
                const key = row.collection + ':' + row.id;
                if (seen.has(key)) { return false; }
                seen.add(key);
                return true;
            })
            .slice(0, BudgetMediaDetailComponent.SIMILAR_MAX)
            .map((row: any) => Object.assign(row, { category: this.category }));
    }

    /**
     * A caption is a narrow search. Below SIMILAR_MIN, search again on the first
     * keyword (or the caption's first word) and add to the list; if that still
     * falls short, show what exists rather than padding with unrelated images.
     */
    private topUpSimilar(): void {
        if (this.relatedProducts.length >= BudgetMediaDetailComponent.SIMILAR_MIN) { return; }

        const caption = (this.images?.caption || '').trim();
        const broader = ((this.images?.tags || []).filter((t: any) => t && String(t).trim())[0]
            || caption.split(/\s+/)[0] || '').trim();

        if (!broader || broader.toLowerCase() === caption.toLowerCase()) { return; }

        const current = this.relatedProducts;
        this.searchSimilar(broader, rows => this.setRelated(current.concat(rows)));
    }

    public changeSize(size: any) {
        if (!size) {
            return;
        }
        this.selectedSize = size;
        this.collectionSize = (this.appService.Data.categories || [])
            .filter((item: any) => item.id == parseInt(this.collection))[0];
        this.cartProduct.size = size.name;
        if (this.cartProduct.type == 'video') {
            if (size.name == 'Web') {
                this.license = 'Web-240';
            }
            if (size.name == 'SD') {
                this.license = 'SD';
            }
            if (size.name == 'HD (1080)') {
                this.license = 'HD';
            }
            if (size.name == 'HD (720)') {
                this.license = 'HD';
            }
            if (size.name == '4K') {
                this.license = '4K';
            }
        }
        this.cartProduct.usage = this.license;
        if (size.price != null && size.price > 0) {
            this.cartProduct.price = size.price;
        } else {
            this.cartProduct.price = this.collectionSize?.price?.[this.license] ?? 0;
        }
        this.btn = (size.is_downloaded || this.isAnySizeDownoaded == 1) ? 2 : (size.subscription > 0 ? 1 : 0);
    }

    public selectSize(value: string) {
        const size = this.images.sizes.filter((item: any) => item.name == value)[0];
        this.changeSize(size);
    }

    public changeLicense(value: string) {
        this.license = value;
        this.selectedLicence = value;
        this.licenseSubscription();
    }

    /* ---------- Layout shared with products/media-detail ---------- */

    /** Standard / Enhanced as picked in the panel. Separate from `license`, which videos reuse for their size tier. */
    selectedLicence = this.licenses[0].name;

    get selectedLicenceInfo(): any {
        return this.licenses.filter(l => l.name == this.selectedLicence)[0] || null;
    }

    /** Which of the three detail sections under the image are expanded. */
    open = { details: true, licence: true, ai: true };

    toggleSection(key: 'details' | 'licence' | 'ai'): void {
        this.open[key] = !this.open[key];
    }

    get isEditorial(): boolean {
        return !!this.images?.iseditorial && (this.images.iseditorial == 'yes' || this.images.iseditorial == true);
    }

    /** The collections whose every image is AI generated. */
    get isAiCollection(): boolean {
        const name = this.collectionSize?.name;
        return name == 'Creative Images' || name == 'IP - AI' || name == 'IP- AI A' || name == 'Ai Generated';
    }

    checkDescription(): boolean {
        return /(^|\s|-)(ai)(\s|-|$)/i.test(this.images?.desc || '');
    }

    get shareUrl(): string {
        return 'https://' + window.location.host + '/product/detail/' + this.mediaType + '/' + this.collection + '/' + this.id;
    }

    /** "864 X 1152" → "864 × 1152". */
    dims(value: any): string {
        return String(value || '').replace(/\s*[xX×]\s*/g, ' × ').trim();
    }

    /** "1152 × 1152 px · 12 × 12 in @ 300 dpi · JPG"; for a video, its pixels and format. */
    sizeSpec(size: any): string {
        if (!size) { return ''; }

        const parts: string[] = [];
        // The API's dpi sometimes already ends in "dpi"; strip it so it is not printed twice.
        const dpi = String(size.dpi || '').replace(/\s*dpi\s*$/i, '').trim();

        if (size.pixels) { parts.push(this.dims(size.pixels) + ' px'); }
        if (this.imageType != 'videos' && size.inches) {
            parts.push(this.dims(size.inches) + ' in' + (dpi ? ' @ ' + dpi + ' dpi' : ''));
        }

        const ext = size.ext || this.images?.ext || (this.images?.filename || '').split('.').pop();
        if (ext && ext !== this.images?.filename) { parts.push(String(ext).toUpperCase()); }

        return parts.join(' · ');
    }

    /** ₹ with Indian digit grouping — "1,50,000", not "150,000". */
    inr(value: any): string {
        return '₹' + (Number(value) || 0).toLocaleString('en-IN');
    }

    /** The image the "Edit with AI" modal is open on; null while it is closed. */
    aiEditSource: AiEditSource | null = null;

    editWithAi(event: Event): void {
        event.preventDefault();
        this.aiEditSource = {
            id: this.images?.id,
            filename: this.images?.filename,
            caption: this.images?.caption,
            thumbnail: this.images?.thumbnail,
            size: this.selectedSize?.pixels ? this.dims(this.selectedSize.pixels) : '',
            source: 'image-detail'
        };
    }

    public getSubscriptionDetail() {
        if (this.currentUser) {
            this.appService.getSubscriptionDetail(this.images.collection, this.images.id, this.images.license, this.images.type).subscribe(data => {
                this.subscription = data;
                this.licenseSubscription();
            });
        }
    }

    private licenseSubscription() {
        if (this.images.type == 'video') {
            this.images.sizes.forEach((obj: any) => {
                if (obj.name == 'Web') {
                    this.license = 'Web-240';
                }
                if (obj.name == 'SD') {
                    this.license = 'SD';
                }
                if (obj.name == 'HD (1080)') {
                    this.license = 'HD';
                }
                if (obj.name == 'HD (720)') {
                    this.license = 'HD';
                }
                if (obj.name == '4K') {
                    this.license = '4K';
                }
                const subFilter = this.subscription.filter((item: any) => item.name == this.license)[0];
                if (!subFilter) {
                    return;
                }
                const siz = subFilter.size.filter((item: any) => item.name == obj.name)[0];
                obj.subscription = subFilter.subscription;
                obj.download_link = siz?.download_link;
                obj.is_downloaded = siz?.is_downloaded;
            });

        } else {
            this.isAnySizeDownoaded = 0;
            const subFilter = this.subscription.filter((item: any) => item.name == this.license)[0];
            if (subFilter) {
                this.images.sizes.forEach((obj: any) => {
                    const siz = subFilter.size.filter((item: any) => item.name == obj.name)[0];
                    obj.subscription = subFilter.subscription;
                    obj.download_link = siz?.download_link;
                    obj.is_downloaded = siz?.is_downloaded;
                    if (obj.is_downloaded) {
                        this.isAnySizeDownoaded = 1;
                    }
                });
            }
        }

        this.changeSize(this.selectedSize);
    }


    chkboxEvent(checked: boolean) {
        this.ackchk = checked;
    }
}

